import { types } from '../actionTypes/InfluencersActionTypes';
import { influencersInitialState } from '../initialState';

const InfluencersReducer = (state = influencersInitialState, action) => {
    const { payload } = action;
    switch (action.type) {
        case types.INFLUENCER_SIGNUP_REQUEST:
            return {
                ...state,
                isInfluencerSignupLoading: true,
                influencerSignupError: null
            };
        case types.INFLUENCER_SIGNUP_SUCCESS:
            return {
                ...state,
                isInfluencerSignupLoading: false,
                influencerSignupError: null
            };
        case types.INFLUENCER_SIGNUP_FAILURE:
            return {
                ...state,
                isInfluencerSignupLoading: false,
                influencerSignupError: payload || 'Failed to sign up'
            };
        case types.GET_INFLUENCERS_REQUEST:
            return {
                ...state,
                influencersListLoading: true
            }
        case types.GET_INFLUENCERS_SUCCESS:
            return {
                ...state,
                influencersListLoading: false,
                influencersList: payload.data,
                totalRecords: payload.totalRecords
            }
        case types.GET_INFLUENCERS_FAILURE:
            return {
                ...state,
                influencersListLoading: false
            }
        case types.CREATE_UPDATE_INFLUENCERS_REQUEST:
            return {
                ...state,
                influencersCreateLoading: true
            }
        case types.CREATE_UPDATE_INFLUENCERS_SUCCESS:
            let updatedList;
            if (payload.mode === 'create') {
                updatedList = [payload.data, ...state.influencersList];
            } else if (payload.mode === 'update') {
                updatedList = state.influencersList.map((item) => {
                    if (item.id === payload.data.id) {
                        return { ...item, ...payload.data }
                    }
                    return item;
                });
            }
            return {
                ...state,
                influencersCreateLoading: false,
                influencersList: updatedList,
                totalRecords: payload.mode === 'create' ? state.totalRecords + 1 : state.totalRecords,
            };
        case types.CREATE_UPDATE_INFLUENCERS_FAILURE:
            return {
                ...state,
                influencersCreateLoading: false
            }
        case types.DELETE_INFLUENCERS_REQUEST:
            return {
                ...state,
                influencersDeleteLoading: true
            }
        case types.DELETE_INFLUENCERS_SUCCESS:
            const updateData = state.influencersList.filter((item) => item.id !== payload.id);
            return {
                ...state,
                influencersDeleteLoading: false,
                influencersList: updateData,
                totalRecords: state.totalRecords - 1
            }
        case types.DELETE_INFLUENCERS_FAILURE:
            return {
                ...state,
                influencersDeleteLoading: false
            }
        case types.CHECK_EXISTING_INFLUENCERS_REQUEST:
            return {
                ...state,
                isExistingInfluencerName: false,
                isCheckExistingInfluencerLoading: true,
            }
        case types.CHECK_EXISTING_INFLUENCERS_SUCCESS:
            return {
                ...state,
                isExistingInfluencerName: true,
                isCheckExistingInfluencerLoading: false,
            }
        case types.CHECK_EXISTING_INFLUENCERS_FAILURE:
            return {
                ...state,
                isExistingInfluencerName: false,
                isCheckExistingInfluencerLoading: false,
            }
        case types.GET_PROMOCODE_REQUEST:
            return {
                ...state,
                createListLoading: true,
            }
        case types.GET_PROMOCODE_SUCCESS:
            return {
                ...state,
                createListLoading: false,
                promoCodeList: payload?.data
            }
        case types.GET_PROMOCODE_FAILURE:
            return {
                ...state,
                createListLoading: false
            }
        case types.CREATE_PROMOCODE_REQUEST:
            return {
                ...state,
                createListLoading: true
            }
        case types.CREATE_PROMOCODE_SUCCESS:
            let updatedPromoList;
            if(payload.mode){
                updatedPromoList = state.promoCodeList.map((promoCode) =>
                    promoCode.id === payload.data.id ? payload.data : promoCode
                );
            }
            else{
                updatedPromoList = [payload.data, ...state.promoCodeList];
            }
            return {
                ...state,
                createListLoading: false,
                promoCodeList: updatedPromoList
            };
        case types.CREATE_PROMOCODE_FAILURE:
            return {
                ...state,
                createListLoading: false
            }
        case types.UPDATE_PROMOCODE_REQUEST:
            return {
                ...state,
                createPromoLoading: true
            }
        case types.UPDATE_PROMOCODE_SUCCESS:
            return {
                ...state,
                createPromoLoading: false,
                /* need to add Payload */
            }
        case types.UPDATE_PROMOCODE_FAILURE:
            return {
                ...state,
                createPromoLoading: false
            }
        case types.DELETE_PROMOCODE_REQUEST:
            return {
                ...state,
                createPromoLoading: true
            }
        case types.DELETE_PROMOCODE_SUCCESS:
            return {
                ...state,
                createPromoLoading: false,
                /* need to add Payload */
            }
        case types.DELETE_PROMOCODE_FAILURE:
            return {
                ...state,
                createPromoLoading: false
            }
        case types.SEND_PAYOUT_REQUEST:
            return {
                ...state,
                influencersPayLoading: true
            }
        case types.SEND_PAYOUT_SUCCESS:           
            return {
                ...state,
                influencersPayLoading: false
            }
        case types.SEND_PAYOUT_FAILURE:
            return {
                ...state,
                influencersPayLoading: false
            }

        default:
            return state
    }
}
export default InfluencersReducer;
